import { Constants } from "@zanichelli/myz-react-utils";

import { call, put, takeEvery, select } from "redux-saga/effects";

import { canUseMyzToken } from "../selectors";
import { alertsAddApiAlert, alertsRemoveApiAlert } from "../Alerts/actions";
import { get, post } from "../../../utils/requestV3MyzToken";

import {
  ISubscriptionEmailRequest,
  SubscriptionEmailAction,
  SubscriptionEmailActionEnum,
  subscriptionEmailFail,
  subscriptionEmailSuccess,
  subscriptionEmailSetEmail,
  subscriptionEmailSetIsSubscribed,
  ISubscriptionEmailFail,
} from "./actions";

export function* subscriptionEmailRequestSaga(
  action: ISubscriptionEmailRequest,
) {
  yield put(alertsRemoveApiAlert());
  yield put(subscriptionEmailSetEmail(action.email));

  let isSubscribed: boolean;
  try {
    const requestURL = `wotd/subscriptions/${action.email}/is-subscribed`;
    yield call(get, requestURL);
    isSubscribed = true;

    const useMyzToken: boolean = yield select(canUseMyzToken);
    if (!useMyzToken) {
      try {
        const requestURL = `wotd/emails/validation`;
        const requestOpt = {
          headers: {},
          body: { email: action.email },
        };
        yield call(post, requestURL, requestOpt);
      } catch (err) {
        yield put(subscriptionEmailFail(err));
        return;
      }
    }
  } catch (err) {
    if (err.response.status === Constants.HttpStatus.NOT_FOUND) {
      isSubscribed = false;
    } else {
      yield put(subscriptionEmailFail(err));
      return;
    }
  }

  yield put(subscriptionEmailSetIsSubscribed(isSubscribed));
  yield put(subscriptionEmailSuccess());
}

export function* subscriptionEmailFailSaga(action: ISubscriptionEmailFail) {
  yield put(alertsAddApiAlert());
}

export function* sagas() {
  yield takeEvery(
    SubscriptionEmailActionEnum.REQUEST,
    subscriptionEmailRequestSaga,
  );
  yield takeEvery(SubscriptionEmailActionEnum.FAIL, subscriptionEmailFailSaga);
}

export interface ISubscriptionEmailState {
  loading: boolean;
  loaded: null | boolean;
  error: null | Error;
  email?: string;
  isSubscribed: null | boolean;
}

const setInitialState = () => {
  return {
    loading: false,
    loaded: null,
    error: null,
    email: undefined,
    isSubscribed: null,
  };
};

const initialState: ISubscriptionEmailState = { ...setInitialState() };

const SubscriptionEmail = (
  state: ISubscriptionEmailState = initialState,
  action: SubscriptionEmailAction,
): ISubscriptionEmailState => {
  switch (action.type) {
    case SubscriptionEmailActionEnum.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SubscriptionEmailActionEnum.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
      };
    case SubscriptionEmailActionEnum.SET_EMAIL:
      return {
        ...state,
        email: action.email,
      };
    case SubscriptionEmailActionEnum.SET_ISSUBSCRIBED:
      return {
        ...state,
        isSubscribed: action.isSubscribed,
      };
    case SubscriptionEmailActionEnum.FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.err,
      };
    case SubscriptionEmailActionEnum.RESET:
      return { ...setInitialState() };
    default:
      return state;
  }
};
export default SubscriptionEmail;
